import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-dark text-white text-center position-fixed bottom-0 w-100">
        <p className='d-flex gap-2 justify-content-center mb-0 pt-1'><i className="fa-solid fa-e"></i><i className="fa-solid fa-minus"></i><i className="fa-solid fa-n"></i><i className="fa-solid fa-o"></i><i className="fa-solid fa-t"></i><i className="fa-solid fa-e"></i><i className="fa-solid fa-b"></i><i className="fa-solid fa-o"></i><i className="fa-solid fa-o"></i><i className="fa-solid fa-k"></i></p>
      <p className='mb-0'>Made with <i className="fa-solid fa-heart" style={{color: "red"}}></i> by Santosh Vishwakarma</p>
    </footer>
  );
};

export default Footer;
